import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
const LawCard = ({
  number,
  title,
  children,
  delay
}: {
  number: string;
  title: string;
  children: React.ReactNode;
  delay: number;
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: 30
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {
    opacity: 0,
    y: 30
  }} transition={{
    duration: 0.6,
    delay,
    ease: 'easeOut'
  }} className="bg-[#0a0a0a] border border-[#222] p-8 rounded-xl relative overflow-hidden group hover:border-[#d4af37]/30 transition-colors duration-500" data-id="element-76">
      <div className="absolute top-0 right-0 p-4 opacity-10 font-serif text-6xl font-bold text-[#d4af37] group-hover:opacity-20 transition-opacity" data-id="element-77">
        {number}
      </div>
      <h3 className="text-xl font-serif text-[#d4af37] mb-4" data-id="element-78">{title}</h3>
      <div className="text-[#8a8578] leading-relaxed space-y-4" data-id="element-79">{children}</div>
    </motion.div>;
};
export function LawsSection() {
  return <section className="w-full bg-[#050505] py-24 px-4 border-t border-[#222]" data-id="element-80">
      <div className="max-w-5xl mx-auto" data-id="element-81">
        <div className="text-center mb-20" data-id="element-82">
          <h2 className="font-serif text-3xl md:text-5xl text-[#f5f0e8] mb-6" data-id="element-83">
            Las leyes mentales que ya están <br data-id="element-84" />
            <span className="text-[#8a8578]" data-id="element-85">gobernando tu trading</span>
          </h2>
          <p className="text-[#8a8578] max-w-2xl mx-auto" data-id="element-86">
            La realidad no negocia con tus deseos. Y tu mente tampoco. Estas son
            las leyes que ya están operando en ti, quieras o no.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-87">
          <LawCard number="1" title="Ley de Causa–Efecto" delay={0} data-id="element-88">
            <p data-id="element-89">
              Tu resultado es un efecto. Tu conducta es la causa. Pero la
              conducta viene de tu estado, y tu estado de tus programas.
            </p>
            <div className="flex items-center gap-2 text-xs md:text-sm text-[#f5f0e8] mt-4 p-3 bg-[#111] rounded border border-[#333] overflow-x-auto" data-id="element-90">
              <span data-id="element-91">Programa</span>
              <span className="text-[#d4af37]" data-id="element-92">→</span>
              <span data-id="element-93">Estado</span>
              <span className="text-[#d4af37]" data-id="element-94">→</span>
              <span data-id="element-95">Decisión</span>
              <span className="text-[#d4af37]" data-id="element-96">→</span>
              <span data-id="element-97">Resultado</span>
            </div>
          </LawCard>

          <LawCard number="2" title="Ley del Ritmo (ciclos)" delay={0.1} data-id="element-98">
            <p data-id="element-99">
              Hay rachas. Hay días fáciles y difíciles. El trader impulsivo
              interpreta el ritmo como identidad ("Soy buenísimo" / "Soy
              terrible").
            </p>
            <p data-id="element-100">
              El trader rentable entiende el ritmo como fenómeno: "Hoy el
              mercado está así. Mi tarea es ejecutar igual."
            </p>
          </LawCard>

          <LawCard number="3" title="Ley de Polaridad" delay={0.2} data-id="element-101">
            <p data-id="element-102">
              Ganar y perder son polos del mismo proceso. Si ganar significa
              "soy valioso" y perder significa "soy un inútil", cada trade es
              una amenaza.
            </p>
            <p data-id="element-103">
              Tu subconsciente te protege: escapando, atacando, controlando o
              evitando.
            </p>
          </LawCard>

          <LawCard number="4" title="Ley de Correspondencia" delay={0.3} data-id="element-104">
            <p className="italic" data-id="element-105">
              "Como piensas, operas. Como operas, te revelas."
            </p>
            <p data-id="element-106">
              Si en tu vida te cuesta sostener incomodidad o buscas validación,
              en el mercado eso se amplifica. El trading no crea tu psicología.
              La expone.
            </p>
          </LawCard>
        </div>
      </div>
    </section>;
}